import { accessRole } from '../../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import DatePicker from '../../../../../helpers/ui/DatePicker'

import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

class IndexView extends Component {

    createBloc = new CreateBloc();
    indexBloc = new IndexBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            employeeListOption:null,
            criteriaListOption:null,
        }
    }


    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.fetchCriteriaList()
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })   
        this.createBloc.criteriaListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        criteriaListOption: result.data?.response?.result
                    });
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })     
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.criteriaListChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`/master/komponen_penilaian_komponen.html`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Tambah Komponen Penilaian</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="assessment_component_type"
                                                className="col-md-3 col-form-label"
                                            >
                                                Jenis Komponen <span className="text-danger">*</span>
                                            </label>
                                            <Col >
                                                <Select
                                                    name="assessment_component_type"
                                                    placeholder="Pilih Jenis Komponen..."
                                                    errorMessage="Pilih Jenis Komponen"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    onChange={(opt) => this.setState({ type: opt.value })}
                                                    options={[
                                                        { label: "Kriteria Penilaian", value: '1' },
                                                        { label: "Komponen Penilaian", value: '2' }
                                                    ]}
                                                />
                                            </Col>
                                        </Row>

                                        {   this.state.type ==='2' &&
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="assessment_component_criteria"
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Kriteria Penilaian <span className="text-danger">*</span>
                                                </label>
                                                <Col >
                                                    <Select
                                                        name="assessment_component_parent_uuid"
                                                        placeholder="Pilih Kriteria Penilaian..."
                                                        errorMessage="Pilih Kriteria Penilaian"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        options={this.state.criteriaListOption}
                                                        optionLabel="assessment_component_name"
                                                        optionValue="assessment_component_uuid"
                                                        isLoading={!this.state.criteriaListOption?.length}
                                                    />
                                                </Col>
                                            </Row>
                                        }

                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" >
                                                Nama {this.state.type ==='2'?"Komponen":"Kriteria"} <span className="text-danger">*</span>
                                            </label>
                                            <Col >
                                                <AvField
                                                    name="assessment_component_name"
                                                    placeholder={`Nama ${this.state.type ==='2'?"Komponen":"Kriteria"}...`}
                                                    type="text"
                                                    errorMessage={`Masukkan Nama ${this.state.type ==='2'?"Komponen":"Kriteria"}`}
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assessment_component_name"
                                                /> 
                                            </Col>
                                        </Row>
                                        {   this.state.type ==='1' &&
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="assessment_component_value"
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Persentase Bobot Penilaian <span className="text-danger">*</span>
                                                </label>
                                                <Col >
                                                    <AvField
                                                        name="assessment_component_value"
                                                        placeholder={`Persentase Bobot Penilaian...`}
                                                        type="number"
                                                        errorMessage={`Persentase Bobot Penilaian`}
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="assessment_component_value"
                                                    /> 
                                                </Col>
                                            </Row>
                                        }
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" >
                                                Berlaku Dari <span className="text-danger">*</span>
                                            </label>
                                            <Col >
                                                <div className="customDatePickerWidth">
                                                    <DatePicker 
                                                        name="assessment_component_start_date"
                                                        id="assessment_component_start_date"
                                                        placeholder="Tanggal Mulai berlaku..."
                                                        errorMessage="Masukkan Tanggal Mulai berlaku"
                                                        isWeekday={true}
                                                        dateFormat="dd/MM/yyyy"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Berlaku Sampai <span className="text-danger">*</span>
                                            </label>
                                            <Col >
                                                <div className="customDatePickerWidth">
                                                    <DatePicker 
                                                        name="assessment_component_end_date"
                                                        id="assessment_component_end_date"
                                                        placeholder="Tanggal selesai berlaku..."
                                                        errorMessage="Masukkan Tanggal selesai berlaku"
                                                        isWeekday={true}
                                                        dateFormat="dd/MM/yyyy"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col ></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/komponen_penilaian_komponen.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView